import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { CynthiaApp } from '@/components/cynthia-app';
import '@/app/globals.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <CynthiaApp />
  </StrictMode>,
);

if ('serviceWorker' in navigator && window.isSecureContext) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => undefined);
  });
}
